import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  ActionIcon,
  AppShell,
  Avatar,
  Box,
  Burger,
  Button,
  Divider,
  Group,
  Menu,
  Modal,
  Paper,
  Text,
  Tooltip,
  UnstyledButton,
  useMantineTheme
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { FaAppStore, FaChevronDown, FaCompressArrowsAlt, FaExpand, FaFacebook, FaGooglePlay, FaLinkedin, FaReddit, FaSignOutAlt, FaWhatsapp } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useApp } from "../contexts/app.context";
import { useAuth } from "../contexts/auth.context";
import { useLanguage } from "../contexts/language.context";
// import JobPage from "../pages/job";
import { RESEND_VALIDATION } from "../services/auth";
import { GET_ALL_INVITES, SEND_INVITE } from "../services/companies";
import { GET_ALL_PROFILES } from "../services/profiles";
import routes from "../utility/routes";
import { useQuery } from "../utility/util";

export type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const theme = useMantineTheme();

  const {
    hasPermission,
    logout,
    role,
    roles,
    userData,
    onChangeRole,
  } = useAuth();
  const { configs, mobileApp } = useApp();
  const { confirmDialog } = useApp();
  const { str } = useLanguage();
  const isMobile = useMediaQuery('(max-width: 991px)');

  const lsOpened: any = localStorage.getItem("@kapo/opened-sidebar");

  const navigate = useNavigate();
  const query = useQuery();

  const location = useLocation();
  const { orderId: paramsOrderId } = useParams();
  const queryOrderId = query.get("order");

  const [opened, setOpened] = useState(false);
  const [openedSidebar, setOpenedSidebar] = useState<boolean>(isMobile ? true : [null, undefined].includes(lsOpened) ? lsOpened === "true" : false);
  const [activeMenu, setActiveMenu] = useState<any>(null);
  const [inviteMails, setInviteMails] = useState({ email: "", profile: null });
  const [profiles, setProfiles] = React.useState<any[]>([]);
  const [invites, setInvites] = React.useState<any[]>([]);
  const [openWorkspaces, setOpenWorkspaces] = React.useState<boolean>(false);

  const handleCloseJob = () => {
    if (paramsOrderId) navigate("/orders");
    if (queryOrderId) {
      query.delete("order");
      navigate(`${location.pathname}${query.toString() ? `?${query.toString()}` : ''}`);
    }
  }

  const loadProfiles = () => {
    GET_ALL_PROFILES()
      .then(res => {
        setProfiles(res);
        setInviteMails(im => ({ ...im, profile: res.find((r: { title: string; }) => r.title === "Project Manager")?._id }))
      })
      .catch(err => { })
  }

  const loadInvites = () => {
    GET_ALL_INVITES()
      .then(res => {
        setInvites(res.filter((i: { profile: { title: string; }; status: number; }) => i?.profile?.title !== "Client" && i.status === 0));
      })
      .catch(err => { })
  }

  const handleInvite = () => {
    // const canInvite = (planData?.seats || []).length > agents.length + invites.length;
    // if(!canInvite){
    //   notifications.show({ message: "To invite someone you need to upgrade your plan seats quantity." , color: 'yellow' })
    //   navigate("/settings#users")
    // }else{
    let previous = inviteMails;
    setInviteMails(im => ({ ...im, email: "" }))
    SEND_INVITE({ email: inviteMails.email, profile: inviteMails.profile })
      .then(res => {
        notifications.show({ message: str(`INVITE_SENT`), color: "green" })
        loadInvites();
      })
      .catch(err => {
        setInviteMails(previous);
        notifications.show({ message: err.message, color: "red" })
      })
    // }
  }

  const resendValidationMail = () => {
    RESEND_VALIDATION()
      .then(() => {
        notifications.show({ message: "Verification e-mail sent", color: "green" })
      })
      .catch((err) => {
        notifications.show({ message: err.message, color: "red" })
      })
  }

  const navbarContent: {
    title: string;
    key: string;
    icon: React.ReactNode;
    url: string;
  }[] = routes
    .filter(
      (route) =>
        route.menu &&
        hasPermission(route) &&
        (!route.condition || route.condition({ user: userData?.user, role }))
    )
    .map(({ title, key, icon, url }) => ({ title, key, icon, url }));

  useEffect(() => {
    localStorage.setItem("@kapo/opened-sidebar", openedSidebar.toString())
  }, [openedSidebar]);

  useEffect(() => {
    if (isMobile) setOpenedSidebar(true)
  }, [isMobile]);

  useEffect(() => {
    loadProfiles()
    loadInvites()
  }, [role]);

  // React.useEffect(() => {
  //   if(orderId){
  //     const handleClickOutside = (event) => {
  //       if (jobRef.current && !jobRef.current.contains(event.target)) {
  //         handleCloseJob();
  //       }
  //     }
  //     document.addEventListener("mousedown", handleClickOutside);
  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }
  // }, [jobRef, orderId]);

  React.useEffect(() => {
    let url = window.location.pathname;
    let findIndex = navbarContent.findIndex((r) => r.url === url);

    if (findIndex !== -1) {
      setActiveMenu(findIndex);
    } else {
      findIndex = navbarContent.findIndex((r) => r.url.split("/").some(s => s && url.split("/").includes(s)));
      if (findIndex !== -1) setActiveMenu(findIndex);
    }
  }, [window.location.pathname]);

  return <AppShell
    header={{ height: 80 }}
    navbar={{
      width: openedSidebar ? 240 : 120, breakpoint: 'md', collapsed: { mobile: !opened },
    }}
    styles={{
      main: {
        // marginRight: -15,
        // marginTop: -17,
        // marginLeft: -15,
        background: '#F2F2F288',
      },
      root: { padding: 0 },
      header: {
        left: isMobile ? 0 : openedSidebar ? 240 : 120,
        // left: 0,
      },
      navbar: {
        top: 0,
        height: '100vh',
        zIndex: 2,
        padding: 0,
        backgroundColor: '#F2F2F2',
        paddingTop: isMobile ? 70 : 0,
      }
    }}
    padding="md"
  >
    <AppShell.Header>
      <div style={{
        backgroundImage: "linear-gradient(270deg, #F2F2F2 0%, #F2F2F2 100%)",
        // backgroundColor: primaryColor,
        zIndex: 2,
        height: 80,
        padding: isMobile ? '0 8px' : '0 20px',
        WebkitBoxShadow: `2px 0px 5px 0px #F2F2F2`,
        MozBoxShadow: `2px 0px 5px 0px #F2F2F2`,
        boxShadow: `2px 0px 5px 0px #F2F2F2`,
        borderBottom: `1px solid #F2F2F2`,
      }}>
        <div
          style={{ display: "flex", alignItems: "center", height: "100%", textAlign: 'center' }}
        >
          {isMobile && <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            size="sm"
            color="white"
            mr="xl"
          />}

          <div style={{ flex: 1 }}></div>

          {/* {!isMobile && <Group style={{flex: 1}} justify="flex-start">
              <img
                onClick={() => { navigate("/") }}
                src={openedSidebar ? configs.image ?? "/icon.png" : configs.icon ?? "/icon.png"}
                alt="kapo"
                style={{ height: 40, objectFit: 'contain', borderRadius: 10, marginRight: 0, cursor: 'pointer' }}
              />
              {navbarContent.map((item, i) => (
                // <Tooltip key={`${i}`} position="bottom" label={item.title}>
                  <Button
                    variant={i === activeMenu ? "filled" : "light"}
                    color="dark"
                    size="sm"
                    onClick={() => {
                      setOpened(false);
                      navigate(item.url);
                      setActiveMenu(i)
                    }}
                  >
                    {str(`NAVBAR.${item.key}`)}
                  </Button>
                // </Tooltip>
              ))}
            </Group>
          } */}

          <Group style={{ gap: isMobile ? 4 : 20 }}>
            {/* <a href="#" data-productlift-sidebar="02df45a5-7738-4bce-9dc6-29f03939171a">Open Widget</a> */}

            {/* <Menu
              position="bottom-end"
              opened={openNotificationsMenu}
              onClose={() => setOpenNotificationsMenu(false)}
              onOpen={() => setOpenNotificationsMenu(true)}
            >
              <Menu.Target>
                <ActionIcon size={36} variant="transparent" color="white">
                  {notificationsList.some(n => !n.read) &&
                    <Badge style={{position: 'absolute', top: -10, right: -10}} size="sm" color="yellow" variant="filled">{notificationsList.filter(n => !n.read).length}</Badge>}
                  <FaBell />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown
                style={{
                  width: 250,
                }}
                m="md"
              >
                <Text p="sm" ta="center">{str("NOTIFICATIONS")}</Text>
                <Menu.Divider />
                <Box style={{maxHeight: 300, overflowY: 'auto'}}>
                  {notificationsList.length === 0 && <Text size="xs" ta="center" p="md">{str("NO_NOTIFICATIONS")}</Text>}
                  {notificationsList.map(not => <>
                    <UnstyledButton p="xs" style={{width: '100%'}} key={not._id} onClick={() => {
                        setOpenNotificationsMenu(false);
                        readNotification(not._id);
                        if(not.job) navigate(`/orders/${not.job._id}`);
                        else if(not.support) navigate(`/support/${not.support._id}`);
                      }}>
                      <Group>
                        <Text style={{flex: 1}} fw={not.read ? "normal" : "bold"} size="sm">{not.title}</Text>
                        {!not.read && <Indicator color="yellow" position="middle-end"></Indicator>}
                      </Group>
                      <Text fw={not.read ? "normal" : "bold"} size="xs">{not.body}</Text>
                      <Text size="xs" ta="right">{getExtenseDatetime(not.createdAt)}</Text>
                    </UnstyledButton>
                    <Divider mt="xs" mb="xs" />
                  </>)}
                </Box>
              </Menu.Dropdown>
            </Menu> */}

            {/* <Menu>
              <Menu.Target>
                <ActionIcon size={36} variant="filled" color="red">
                  <img
                    src={availableLanguages.find(al => al.key === lang)?.icon ?? "/countries/us.png"}
                    style={{width: 20, height: 20, objectFit: 'contain'}} />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                {
                  availableLanguages.filter(al => al.key !== lang).map(al => (
                    <Menu.Item
                      onClick={() => translateStrings(al.key)}
                      leftSection={al.icon && <img src={al.icon} style={{width: 20, height: 20, objectFit: 'contain'}} />}
                    >
                      {al.title}
                    </Menu.Item>
                  ))
                }
              </Menu.Dropdown>
            </Menu> */}

            {/* <Menu>
              <Menu.Target>
                <ActionIcon size={36} variant="transparent" color="white">
                  <img
                    src={availableLanguages.find(al => al.key === lang)?.icon ?? "/countries/us.png"}
                    style={{ width: 20, height: 20, objectFit: 'contain' }} />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                {
                  availableLanguages.filter(al => al.key !== lang).map(al => (
                    <Menu.Item
                      onClick={() => setLang(al.key)}
                      leftSection={al.icon && <img src={al.icon} style={{ width: 20, height: 20, objectFit: 'contain' }} />}
                    >
                      {al.title}
                    </Menu.Item>
                  ))
                }
              </Menu.Dropdown>
            </Menu> */}

            <Menu>
              <Menu.Target>
                <UnstyledButton>
                  <Group>
                    <Avatar src={userData?.user?.image} />
                    <Text size="sm" w="bold">
                      {(userData?.user?.name ?? "").split(" ").slice(0,2).join(" ")}
                    </Text>
                  </Group>
                </UnstyledButton>
              </Menu.Target>
              <Menu.Dropdown
                style={{
                  minWidth: 300,
                  marginLeft: "-10px",
                  marginTop: "2px",
                }}
              >
                {/* <RolesSelect /> */}
                {/* <Menu.Divider /> */}
                {/* <Menu.Item color="gray" onClick={() => window.open("https://aprova.ai/privacy-policy/", "_blank")}>Políticas de Privacidade</Menu.Item> */}
                <Menu.Item color="gray" onClick={logout}>Sair</Menu.Item>
              </Menu.Dropdown>
            </Menu>
            {/* <UnstyledButton
              size={36}
              onClick={() => navigate("/settings#profile")}
            >
              <Avatar src={userData?.user?.image} />
            </UnstyledButton> */}
          </Group>
        </div>
      </div>
    </AppShell.Header>

    <AppShell.Navbar>
      <AppShell.Section grow style={{ overflowY: "auto" }}>
        <div style={{ textAlign: 'center', padding: '40px 0 20px 0' }}>
          {<img
            src={openedSidebar ? configs.image ?? "/logo.png" : configs.icon ?? "/logo.png"}
            alt="kapo"
            style={{ maxHeight: isMobile ? 30 : 40, maxWidth: isMobile ? '40%' : '80%', objectFit: 'contain' }}
          />}
          {/* {openedSidebar && <h2 style={{margin: 0}}>aluguekapo.com.br</h2>} */}
        </div>
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: openedSidebar ? undefined : 'center' }}>
          {/* {openedSidebar && <UnstyledButton
            onClick={() => setOpenWorkspaces(true)} style={{ width: '100%', padding: 20 }}>
            <Paper p="xs" pl="md" pr="md">
              <Group>
                <Text style={{ flex: 1 }} size="sm" fw="bold">{role?.company?.name ?? userData?.user?.name}</Text>
                <FaChevronDown />
              </Group>
            </Paper>
          </UnstyledButton>} */}

          {/* <div style={{
            background: '#FFFFFF',
            height: openedSidebar ? 65 : 50,
            position: 'absolute',
            top: navbarContent.findIndex((n,i) => i === activeMenu) > 0 ? navbarContent.findIndex((n,i) => i === activeMenu) * 65 : 0,
            left: 0,
            right: 0,
            zIndex: -1,
            transition: `0.3s all ease`,
            borderBottom: '4px solid #000000',
            borderRight: '1px solid #000000',
            borderLeft: '1px solid #000000',
            borderTop: '1px solid #000000',
          }}></div> */}
          {navbarContent.map((item, i) => (
            // <Tooltip key={`${i}`} position="bottom" label={item.title}>
            <UnstyledButton
              style={{
                // width: '100%',
                padding: !openedSidebar ? '0 8px' : '8px 20px',
              }}
              onClick={() => {
                setOpened(false);
                setActiveMenu(i)
                navigate(item.url);
              }}
            >
              <Group
                style={{
                  borderRadius: 6,
                  marginBottom: 10,
                  ...(openedSidebar ? { padding: 10 } : { display: 'flex', justifyContent: 'center', padding: '6px' }),
                  ...((i === activeMenu) ? {
                    border: '1px solid #014040',
                  } : {})
                }}
              >
                {<ActionIcon
                  variant="transparent"
                  // style={{ color: i === activeMenu ? "white" : "dark" }}
                  style={{ color: "dark" }}
                  key={item.key}
                >{item.icon}</ActionIcon>}
                {openedSidebar && <Text
                  size="sm"
                  style={{
                    fontWeight: 'bold',
                    textAlign: 'center',
                    // color: i === activeMenu ? "white" : "dark",
                    color: "dark"
                  }}
                >
                  {str(`NAVBAR.${item.key}`)}
                </Text>}
              </Group>
            </UnstyledButton>
            // </Tooltip>
          ))}
        </div>
      </AppShell.Section>
      {
        openedSidebar && userData?.company?.defaultDomain && role?.profile?.title !== "Client" && <AppShell.Section mb="xs">
          <Group align="center" justify="center" mt="xs">
            <Tooltip label="Share on Facebook"><ActionIcon variant="light" onClick={() => {
              window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(userData?.company?.defaultDomain)}`, '_blank');
            }}><FaFacebook /></ActionIcon></Tooltip>
            <Tooltip label="Share on Whatsapp"><ActionIcon variant="light" onClick={() => {
              window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(userData?.company?.name)}%20-%20${encodeURIComponent(userData?.company?.defaultDomain)}`, '_blank');
            }}><FaWhatsapp /></ActionIcon></Tooltip>
            <Tooltip label="Share on Reddit"><ActionIcon variant="light" onClick={() => {
              window.open(`https://www.reddit.com/submit?url=${encodeURIComponent(userData?.company?.defaultDomain)}&title=${encodeURIComponent(userData?.company?.name)}`, '_blank');
            }}><FaReddit /></ActionIcon></Tooltip>
            <Tooltip label="Share on X (Twitter)"><ActionIcon variant="light" onClick={() => {
              window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(userData?.company?.defaultDomain)}&text=${encodeURIComponent(userData?.company?.name)}`, '_blank');
            }}><FontAwesomeIcon icon={["fab", "x-twitter"]} /></ActionIcon></Tooltip>
            <Tooltip label="Share on Linkedin"><ActionIcon variant="light" onClick={() => {
              window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(userData?.company?.defaultDomain)}`, '_blank');
            }}><FaLinkedin /></ActionIcon></Tooltip>
          </Group>
        </AppShell.Section>
      }
      {
        mobileApp?.developer?.deployed && role?.profile?.title === "Client" && <Paper style={{ borderColor: '#FFFFFF' }} p="xl">
          <Text size="xs" mb="md" ta="center">Download The Mobile App</Text>
          <Group>
            {mobileApp?.developer?.play_store_url && <Box style={{ flex: 1 }}>
              <Paper onClick={() => window.open(mobileApp?.developer?.play_store_url, "_blank")} p="xs" style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', borderRadius: 10, flexDirection: 'row', alignItems: 'center', background: '#FFFFFF' }}>
                <FaGooglePlay size={18} color="#000000" />
              </Paper>
            </Box>}
            {mobileApp?.developer?.apple_url && <Box style={{ flex: 1 }}>
              <Paper onClick={() => window.open(mobileApp?.developer?.apple_url, "_blank")} p="xs" style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', borderRadius: 10, flexDirection: 'row', alignItems: 'center', background: '#FFFFFF' }}>
                <FaAppStore size={18} color="#000000" />
              </Paper>
            </Box>}
          </Group>
        </Paper>
      }
      {
        !isMobile && <AppShell.Section>
          <Tooltip
            position="right"
            label={openedSidebar ? str("COLLAPSE") : str("EXPAND")}
          >
            <Box>
              {true
                ? <Button
                  onClick={() => setOpenedSidebar(s => !s)}
                  fullWidth
                  variant="transparent"
                  size="xs"
                  leftSection={<FaCompressArrowsAlt />}
                >{openedSidebar ? str("COLLAPSE") : str("EXPAND")}</Button>
                : <ActionIcon
                  ml="xs" mb="xs" variant="transparent" onClick={() => setOpenedSidebar(s => !s)} size="lg"><FaExpand /></ActionIcon>}
              <Text></Text>
            </Box>
          </Tooltip>
        </AppShell.Section>
      }
    </AppShell.Navbar >

    <AppShell.Main>
      <div style={{ position: 'relative' }}>
        <div id="principal-content" style={{ padding: '0 0 200px 0' }}>
          <div style={{ padding: isMobile ? 0 : 0 }}>
            {children}
          </div>
        </div>

        {/* {user && !userData?.user?.verified && <UnstyledButton style={{ width: '100%' }} onClick={resendValidationMail}>
          <Box p="xl" style={{ position: 'fixed', borderTop: '1px solid #8a8a8a', zIndex: 10, left: 0, bottom: 0, right: 0, textAlign: 'center', background: '#014040' }}>
            <Text c="white">{str("MAIL_VERIFICATION_TITLE")}</Text>
            <Text c="white" fw="bold">{str("MAIL_VERIFICATION_SUBTITLE")}</Text>
          </Box>
        </UnstyledButton>} */}
      </div>

      <Modal
        opened={openWorkspaces}
        onClose={() => setOpenWorkspaces(false)}
      >
        <Text size="md" c="white">Workspaces</Text>
        <Divider mt="md" mb="md" />
        {roles.filter(r => r.company._id !== role?.company?._id).length === 0 && <Text mt="sm" size="md" c="gray">No other workspace</Text>}
        {
          roles.filter(r => r.company._id !== role?.company?._id).map(role => <>
            <Button
              fullWidth
              variant="transparent"
              c="white"
              size="md"
              onClick={() => {
                onChangeRole(role._id);
                // navigate("/");
              }}
            >{role?.company?.name}</Button>
            <Divider mt="md" mb="md" />
          </>)
        }
        <Box mt="md" mb="md">
          {/* {role && roles.some(r => r.company._id === role.company._id && r.profile.title !== "Client") &&
          <Switch mb="md" label="View as Client" checked={role?.profile?.title === "Client"} onChange={() => {
            onChangeRole(role._id, role?.profile?.title !== "Client")
          }} />} */}
          {/* <RolesSelect /> */}
          {/* <Text mt="xs" align="left" size="md" c="dark" fw="bold">Language</Text> */}
        </Box>
        <Button
          onClick={() => {
            confirmDialog(
              { text: str("CONFIRMATION.LOGOUT") },
              ({ confirmed }) => {
                if (confirmed) logout();
              }
            );
          }}
          leftSection={<FaSignOutAlt />}
        >{str("LOGOUT")}</Button>
      </Modal>

    </AppShell.Main>
  </AppShell >
};

export default Layout;
